<script setup lang="ts">
import { type LiveOpsChallengeWinnerNotification } from '@/types/shared/player'
import { CHALLENGE_PRIZE_TYPE } from '@/types/shared/player-config'
import { allSpecialCurrenciesConfig } from '@/config/special-currencies'
import BaseChallengeWinnerModal from '@/components/modals/BaseChallengeWinnerModal.vue'
import { formatNumberSemiTruncate } from '@/helpers/utils'
import { computed } from 'vue'
import { leaderboards } from '@/composables/game/live-ops-challenge'
import { LiveOpsLeaderboardType } from '@/types/live-ops'
import CheckCircleIcon from '@/assets/images/check-circle-transparent.png'

const props = defineProps<{
  show: boolean,
  notification: LiveOpsChallengeWinnerNotification
}>()

defineEmits(['hide'])

const leaderboard = computed(() => {
  return leaderboards.value.find(lb => lb.name === props.notification.leaderboardName)
})

const mainColor = computed(() => leaderboard.value?.mainColor ?? '#B8852E')
const mainIconUrl = computed(() => leaderboard.value?.mainIconUrl)

const scoreImage = computed(() => {
  return leaderboard.value?.config.type === LiveOpsLeaderboardType.REWARDED_CURRENCY
    ? allSpecialCurrenciesConfig.value[leaderboard.value.config.currency]?.image
    : CheckCircleIcon
})
const timerBackgroundStyle = computed(() => ({
  background: `linear-gradient(90deg, ${mainColor.value} 0%, ${mainColor.value}99 50%, #1E1B4B 100%)`,
}))

const notification = computed((): LiveOpsChallengeWinnerNotification => {
  const n = props.notification
  if (n.prizeType === CHALLENGE_PRIZE_TYPE.SPECIAL_CURRENCY && n.liveOpsRewards?.[0]?.currency) {
    return { ...n, specialCurrencyId: n.liveOpsRewards[0].currency }
  }
  return n
})
</script>

<template>
  <BaseChallengeWinnerModal
    :show="show"
    :notification="notification"
    :main-image="mainIconUrl ?? ''"
    main-image-class="size-[175px]"
    :main-image-background-class="`z-[101] size-[175px]`"
    :timer-background-style="timerBackgroundStyle"
    :description="`Congrats, you're a ${notification.leaderboardName} winner!`"
    :score-image="scoreImage"    
    :score-value="formatNumberSemiTruncate(notification.score)"
    @hide="$emit('hide')"
  />
</template>
